module.exports = process.env.NODE_ENV === 'development' ? require("./env.prod") : require("./env.prod")
